import "./container.scss";

export const Container = ({ children }) => (
  <div className="landing-container">{children}</div>
);
